var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu_svg__menu",
    width: 37.95,
    height: 37.95
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".menu_svg__cls-2{fill:#8387a5}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu_svg__Rectangle_202",
    fill: "none",
    d: "M0 0h37.95v37.95H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "menu_svg__menu-2",
    d: "M0 0h19.969v2.219H0z",
    className: "menu_svg__cls-2",
    transform: "rotate(-45 35.918 -.546)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "menu_svg__menu-3",
    d: "M0 0h20v2.222H0z",
    className: "menu_svg__cls-2",
    transform: "rotate(45 -6.97 21.133)"
  })));
}

export default SvgMenu;